




























































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";

// Types
import { ICurrency } from "@/models/constants";

@Component
export default class EditablePrice extends Mixins(HasValidation) {
  @Prop({ default: true })
  public canEdit!: boolean;

  @Prop({ default: "" })
  public instruction!: string;

  @Prop({ required: true })
  public value!: number;

  @Prop({ default: 0.0 })
  public minValue!: number;

  @Prop({ default: null })
  public maxValue!: number;

  @Prop({ default: null })
  public originalValue!: number;

  @Prop({ default: "" })
  public prefix!: string;

  @Prop({ default: "" })
  public suffix!: string;

  @Prop({ default: null })
  public valueFormatted!: string;

  @Prop({ default: false })
  public isLoading!: string;

  @Prop({ default: "price" })
  public inputId!: string;

  @Prop({ default: true })
  public showIcon!: string;

  @Prop({ default: null })
  public originalValueFormatted!: string;

  @Prop({ required: true })
  public currency!: ICurrency;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "is-bottom-left" })
  public position!: string;

  public currentValue = 0;
  public isActive = false;

  public editPriceDropdownToggled(active: boolean) {
    this.isActive = active;
    if (!active) return;
    this.currentValue = this.value;
  }

  public get isPriceEdited() {
    return (
      this.originalValueFormatted &&
      this.valueFormatted !== this.originalValueFormatted
    );
  }

  public get showResetDefault() {
    return (
      this.originalValue !== null &&
      this.value >= 0 &&
      this.value !== this.originalValue
    );
  }

  public resetDefault() {
    this.$emit("input", this.originalValue);
    this.togglePopover();
  }

  public emitInput() {
    if (
      this.currentValue < 0 ||
      this.currentValue === null ||
      this.hasErrors ||
      this.isDisabled
    ) {
      return;
    }
    this.$emit("input", this.currentValue);
    this.togglePopover();
  }

  public togglePopover() {
    // @ts-ignore
    this.$refs["edit-price-popover"].toggle();
  }
}
